import validate from "/app/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.4.1_@types+node@18.19.9_eslint@8.57.1_ioredis@5.7.0_less@4.1.3__fzg2v5mngtqrordpocizjuqpdi/node_modules/nuxt/dist/pages/runtime/validate.js";
import order_45global from "/app/apps/concierge/src/middleware/order.global.js";
import whitelabel_45global from "/app/apps/concierge/src/middleware/whitelabel.global.js";
export const globalMiddleware = [
  validate,
  order_45global,
  whitelabel_45global
]
export const namedMiddleware = {}